import type { WakeLoopDaemonTaskResultPayload } from "@wakeloop/schemas/types";
import { toErrorMessage } from "../core/logger";
import {
  DaemonServiceRunError,
  type WakeLoopDaemonTaskErrorType,
} from "../core/types";

export function toTaskExecutionError(error: unknown): {
  errorCode: string;
  errorType: WakeLoopDaemonTaskErrorType;
  message: string;
  openClawGatewayVisibility?: WakeLoopDaemonTaskResultPayload["openClawGatewayVisibility"];
} {
  if (error instanceof DaemonServiceRunError) {
    return {
      errorCode: error.code,
      errorType: "config",
      message: error.message,
      openClawGatewayVisibility: error.openClawGatewayVisibility,
    };
  }
  return {
    errorCode: "dispatch.execution_failed",
    errorType: "internal",
    message: toErrorMessage(error),
  };
}
